import React from 'react';
import { useSelector } from 'react-redux';
import { AI_TOOLS } from '@constants';
import { logger } from '@utils/usefulFuncs';

const forcedPermissions = [];

const addForcedPermission_dev = (permission, heading, route, icon, desc) => {
  forcedPermissions.push({
    description: desc || 'Description here',
    heading: heading || 'New mode',
    icon_key: icon || 'custom',
    route: route,
  });
};

// addForcedPermission_dev(
//   AI_TOOLS.QUERY_ENGINE,
//   'QUERY_ENGINE',
//   ROUTES.queryEngine,
//   'watchlist',
//   'See your history of questions and answers you have asked Digital Analyst'
// );

export const useHasBetaFeaturesEnabled = () => useCurrentUser()?.is_nvstr_employee;

export const useCurrentUser = () => useSelector((state) => state.currentUser);

export const isCurrentUserBrokerageUser = (user) => {
  if (user && 'has_digital_analyst_access' in user) {
    return !user.has_digital_analyst_access && !user.is_digital_analyst_signup;
  }
  return false;
};

export const isPotentialBrokerageUser = (user) => {
  return user && !user.is_digital_analyst_signup;
};

export const isCurrentUserAccountDeleted = (user) => {
  if (!user) {
    return false;
  }
  return user.is_account_closed && !user.has_digital_analyst_access;
};

export const useIsV2SentimentEnabled = () => {
  const perms = useCurrentUserToolsAvailable();
  return perms?.includes(AI_TOOLS.FED_SENTIMENT_V2) || false;
};

export const useTrialExpiry = () => {
  const user = useCurrentUser();
  const trialExpiry = user?.digital_analyst_trial_expiry;
  if (!trialExpiry) {
    return null;
  } else {
    return trialExpiry;
  }
};

export const usePartnerTheme = () => {
  return useCurrentUser()?.custom_client_id;
};

export const useCurrentUserPermissions = () => {
  const [noPermissions] = React.useState([]);
  return useCurrentUser()?.ai_allowed_doc_types || noPermissions;
};

export const usePermissionedModes = () => {
  const [noPermissionModes] = React.useState([]);
  const user = useCurrentUser();
  const permissionedModes = user?.permissioned_modes_metadata;
  const userProp = permissionedModes ? Object.values(permissionedModes) : noPermissionModes;
  return [...userProp, ...forcedPermissions];
};

export const usePermissionedModesV2 = () => {
  const user = useCurrentUser();
  const rawGroups = user?.grouped_permissioned_modes_metadata;
  const groups = [];
  const ungrouped = [];

  if (!rawGroups) {
    return null;
  }

  rawGroups.forEach((g) => {
    if (g.group_name) {
      groups.push(g);
    } else {
      const modes = g.modes;
      modes.forEach((m) => {
        logger('ungrouped permission', g);
      });
    }
  });
  if (forcedPermissions.length > 0) {
    const group = {
      group_name: 'Misc',
      modes: [],
    };
    forcedPermissions.forEach((m) => group.modes.push(m));
    ungrouped.push(group);
  }

  return {
    groups,
    ungrouped,
  };
};

export const useCurrentUserToolsAvailable = () => {
  const [noTools] = React.useState([]);
  const currentUser = useCurrentUser();
  // logger('permissions', currentUser?.ai_allowed_mode_types.sort());
  return currentUser?.ai_allowed_mode_types || noTools;
};

export const useIsTornadoEmployee = () => {
  const currentUser = useCurrentUser();
  return currentUser?.is_nvstr_employee || false;
};

export const useApiKeysEnabled = () => {
  const currentUser = useCurrentUser();
  return currentUser?.api_access_enabled === true;
};
